import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import './Produtos.css';
import MenuLateral from "../Components/MenuPrincipal/MenuLateral";
import ProdutoForm from "../Components/ProdutoForm/ProdutoForm";
import { useAuth } from "../Context/auth";

function EditarProduto() {
    const { currentUser } = useAuth();
    const navigate = useNavigate();
    const { id: produtoId } = useParams();
    const [initialData, setInitialData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [mensagem, setMensagem] = useState('');

    useEffect(() => {
        if (!produtoId || !currentUser) return;
        const buscarProduto = async () => {
            setLoading(true);
            try {
                const token = await currentUser.getIdToken();
                const API_URL = process.env.REACT_APP_API_URL;
                const response = await fetch(`${API_URL}/api/produtos/${produtoId}`, {
                    headers: { 'Authorization': `Bearer ${token}` }
                });
                if (!response.ok) throw new Error('Produto não encontrado ou acesso negado.');
                const data = await response.json();
                setInitialData(data);
            } catch (error) {
                console.error("Erro ao carregar o produto:", error);
                setMensagem(error.message);
            } finally {
                setLoading(false);
            }
        };
        buscarProduto();
    }, [produtoId, currentUser]);

    async function handleEditar(formData) {
        setMensagem('');
        setLoading(true);
        try {
            const token = await currentUser.getIdToken();
            const API_URL = process.env.REACT_APP_API_URL;
            const response = await fetch(`${API_URL}/api/produtos/${produtoId}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
                body: JSON.stringify(formData)
            });
            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.error || "Erro ao atualizar produto.");
            }

            // Ao salvar com sucesso, atualizamos os dados iniciais para "resetar" o estado de dirty do form
            // Podemos buscar novamente do servidor para garantir consistência total
            // Ou atualizar com o que enviamos (mas o servidor pode ter triggers etc.)
            // Vamos buscar novamente para segurança.

            setMensagem(''); // Limpa mensagens anteriores

            // Re-fetch data
            const checkResponse = await fetch(`${API_URL}/api/produtos/${produtoId}`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            if (checkResponse.ok) {
                const newData = await checkResponse.json();
                setInitialData(newData);
                Swal.fire({
                    title: 'Sucesso!',
                    text: 'Produto atualizado com sucesso.',
                    icon: 'success',
                    timer: 1500,
                    showConfirmButton: false
                });
            } else {
                navigate('/app/produtos'); // Fallback se falhar o refetch
            }

        } catch (erro) {
            setMensagem(erro.message);
        } finally {
            setLoading(false);
        }
    }

    return (
        <div className="produtos-page-container" style={{ display: 'flex', paddingTop: 0 }}>
            <MenuLateral />
            <div className="content-with-sidebar">
                <div className="produtos-header">
                    <div className="d-flex align-items-center gap-3">
                        <button className="btn btn-link text-secondary p-0" onClick={() => navigate('/app/produtos')} title="Voltar">
                            <i className="fas fa-arrow-left fa-lg"></i>
                        </button>
                        <h1 className="produtos-title m-0">
                            Editar <span className="highlight">Produto</span>
                        </h1>
                    </div>
                </div>

                <main className="produtos-content">
                    {mensagem && !initialData && (
                        <div className="alert alert-danger d-flex align-items-center mb-4" role="alert">
                            <i className="fas fa-exclamation-circle me-2"></i>
                            <div>{mensagem}</div>
                        </div>
                    )}

                    {initialData ? (
                        <ProdutoForm
                            initialData={initialData}
                            onSubmit={handleEditar}
                            isEditing={true}
                            loading={loading}
                        />
                    ) : (
                        loading ? (
                            <div className="d-flex justify-content-center align-items-center w-100 flex-column" style={{ marginTop: '100px' }}>
                                <div className="spinner-border text-primary" role="status">
                                    <span className="visually-hidden">Carregando...</span>
                                </div>
                                <p className="mt-2 text-muted">Carregando produto...</p>
                            </div>
                        ) : (
                            <div className="alert alert-warning text-center">
                                Produto não encontrado.
                            </div>
                        )
                    )}
                </main>
            </div>
        </div>
    );
}

export default EditarProduto;